<!-- <app-preloader></app-preloader> -->
 <main class="main-layout-content">
<router-outlet></router-outlet>
</main>
<app-footer *ngIf="!(location == '/login' || location == '/register' || location == '/forgot-password')"></app-footer>